import {useSelector} from '../../../store.js'
import {settingsPermissionsSelector} from '../settingsFunctions.js'
import {
  contactsSortedByNicknameSelector,
  deleteContact,
} from '../../../data/contacts.js'
import SettingsPanel from '../SettingsPanel.js'
import ButtonPrimary from '../../../common/components/Button/ButtonPrimary.js'
import ButtonLink from '../../../common/components/Button/ButtonLink.js'
import Icon from '../../../common/icons/Icon.js'
import {showAddEditContactModal} from './AddEditContactModal.js'

function ContactRow({contact}) {
  return (
    <li className="list__item flex--justify divider--bottom">
      <div className="w-80">
        <div>
          <strong className="fs-01 lh-md">{contact.nickname}</strong>
        </div>
        <div>
          <ButtonLink
            className="fs-n0 lh-md"
            onClick={() => showAddEditContactModal(contact.id)}
          >
            Edit
          </ButtonLink>
        </div>
      </div>
      <div>
        <ButtonLink
          className="no-underline"
          title="Delete contact"
          onClick={() => deleteContact(contact.id)}
        >
          <Icon name="trash" className="fs-00 lh-md" />
        </ButtonLink>
      </div>
    </li>
  )
}

export default function Contacts() {
  const hasPermission = useSelector(settingsPermissionsSelector).contacts
  const contacts = useSelector(contactsSortedByNicknameSelector)

  return (
    <SettingsPanel header="Contacts" hasPermission={hasPermission}>
      <div className="row">
        <div className="medium-7 columns">
          <div className="flex--justify align-items-center margin-bottom-0">
            <p className="fs-01 lh-md w-65 margin-bottom-15">
              Add reusable contacts for all outbound communication from Ordoro.
            </p>
            <div className="margin-bottom-15">
              <ButtonPrimary
                onClick={() => showAddEditContactModal()}
                size="md"
              >
                Add a Contact
              </ButtonPrimary>
            </div>
          </div>
          <hr className="margin-top-5 margin-bottom-15" />
          <ul className="list margin-bottom-25">
            {contacts.map((contact) => (
              <ContactRow key={contact.id} contact={contact} />
            ))}
          </ul>
        </div>
      </div>
    </SettingsPanel>
  )
}
